import { render, staticRenderFns } from "./SalesDepartmentUKbranch.vue?vue&type=template&id=61ffe9af&scoped=true"
import script from "./SalesDepartmentUKbranch.vue?vue&type=script&lang=js"
export * from "./SalesDepartmentUKbranch.vue?vue&type=script&lang=js"
import style0 from "./SalesDepartmentUKbranch.vue?vue&type=style&index=0&id=61ffe9af&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ffe9af",
  null
  
)

export default component.exports